import { render, staticRenderFns } from "./CsatTable.vue?vue&type=template&id=2f7564e9&scoped=true"
import script from "./CsatTable.vue?vue&type=script&lang=js"
export * from "./CsatTable.vue?vue&type=script&lang=js"
import style0 from "./CsatTable.vue?vue&type=style&index=0&id=2f7564e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7564e9",
  null
  
)

export default component.exports